import React from 'react';
import { View } from 'react-native';
import { useThemedStyles } from '../../hooks/useThemedStyles';

import Settings from './Settings';

const SettingsView = () => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={styles.container}>
			<Settings />
		</View>
	);
};

const createStyles = ({ ui: { colors } }) => ({
	container: {
		backgroundColor: colors.canvas,
		flex: 1,
	},
});

export default React.memo(SettingsView);
